/**
 * This mixin is used to get Site Selector Card and Site Location Zone Card href.
 */
import { deletePrefix } from 'src/router/utils'
export default {
  configuration: ['currentSite'],
  emits: ['select', 'select-location'],
  data () {
    return {
      checked: false
    }
  },
  computed: {
    cardColorCss () {
      if (this.cardColor === 'custom') {
        return this.$isColorDark(this.cardColorHex) ? 'text-white' : 'text-black'
      } else if (this.cardColor === 'default') {
        return 'text-responsive bg-transparent'
      } else {
        return `bg-${this.cardColor} ${this.$getTextColor(this.currentSite, this.cardColor)}`
      }
    },
    siteHref () {
      if (this.redirectHomePage) {
        return this.$appendCurrentQueryParams(`${this.site.url()}?preferred`)
      }

      let currentPath = window.location.pathname
      if (this.currentSite.rootPath !== '/' && _.startsWith(currentPath, this.currentSite.rootPath)) {
        currentPath = deletePrefix(currentPath, this.currentSite.rootPath)
      }
      return this.$appendCurrentQueryParams(`${this.site.url(currentPath)}?preferred`)
    }
  },
  watch: {
    selectedLocations: {
      handler () {
        this.checked = _.some(this.selectedLocations, location => location.id === this.site.id)
      }
    }
  },
  mounted () {
    this.checked = _.some(this.selectedLocations, location => location.id === this.site.id)
  },
  methods: {
    trackOrSelectSiteSelection () {
      if (this.navigateOnSelect) {
        this.$trackEvent(this.$customerEvents.CLICKED_SITE_SELECTOR_ON_NAVIGATION)
        this.$emit('select')
      } else {
        this.$emit('select-location', this.site, this.checked ? 'add' : 'remove')
      }
    },
    selectSiteSelection () {
      this.$emit('select-location', this.site, this.checked ? 'add' : 'remove')
    }
  }
}
